import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCalendarAlt, faMicrophone, faHeart, faClock, faBookOpen, faUsers } from '@fortawesome/free-solid-svg-icons';
import '../../styles/group/GroupTabs.css';

const GroupTabs = ({ activeTab, onTabChange, searchBarVisible = true, isAdmin = false }) => {
  return (
    <div className={`group-tabs-wrapper ${!searchBarVisible ? 'search-hidden' : ''}`}>
      <div className="group-tabs-container">
        <div 
          className={`tab-item ${activeTab === 'upcoming' ? 'active' : ''}`}
          onClick={() => onTabChange('upcoming')}
        >
          <FontAwesomeIcon icon={faClock} className="tab-icon" />
          <span className="tab-label">Upcoming</span>
          {activeTab === 'upcoming' && <div className="active-indicator"></div>}
        </div>
        
        <div 
          className={`tab-item ${activeTab === 'events' ? 'active' : ''}`}
          onClick={() => onTabChange('events')}
        >
          <FontAwesomeIcon icon={faCalendarAlt} className="tab-icon" />
          <span className="tab-label">Events</span>
          {activeTab === 'events' && <div className="active-indicator"></div>}
        </div>
        
        <div 
          className={`tab-item ${activeTab === 'classes' ? 'active' : ''}`}
          onClick={() => onTabChange('classes')}
        >
          <FontAwesomeIcon icon={faMicrophone} className="tab-icon" />
          <span className="tab-label">Classes</span>
          {activeTab === 'classes' && <div className="active-indicator"></div>}
        </div>
        
        <div 
          className={`tab-item ${activeTab === 'prayer' ? 'active' : ''}`}
          onClick={() => onTabChange('prayer')}
        >
          <FontAwesomeIcon icon={faBookOpen} className="tab-icon" />
          <span className="tab-label">Prayer</span>
          {activeTab === 'prayer' && <div className="active-indicator"></div>}
        </div>
        
        {/* Members & Requests tab - Only visible to admins */}
        {isAdmin && (
          <div 
            className={`tab-item ${activeTab === 'memberships' ? 'active' : ''}`}
            onClick={() => onTabChange('memberships')}
          >
            <FontAwesomeIcon icon={faUsers} className="tab-icon" />
            <span className="tab-label">Members</span>
            {activeTab === 'memberships' && <div className="active-indicator"></div>}
          </div>
        )}
      </div>
    </div>
  );
};

export default GroupTabs;